import {
  Box,
  Container,
  IconButton,
  InputAdornment,
  Typography,
} from '@material-ui/core'
import { SearchOutlined } from '@material-ui/icons'
import AddIcon from '@material-ui/icons/Add'
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined'
import classNames from 'classnames'
import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'

import Button from '@/components/button'
import InputText from '@/components/input-text'
import Loading from '@/components/loading'
import {
  DiagnosisDTO,
  useGetPhysiologicalDiagnoses,
} from '@/hooks/queries/use-get-physiological-diagnoses'
import { routes } from '@/routes/config'

import { DiagnosesTable } from './diagnoses-table'
import { useStyles } from './styles'

export default function Diagnoses() {
  const classes = useStyles()
  const [search, setSearch] = useState('')
  const [filteredSearch, setFilteredSearch] = useState('')

  const { data: diagnoses, isLoading } = useGetPhysiologicalDiagnoses(
    {},
    {
      onError: () => {
        toast('Não foi possível carregar os diagnósticos', { type: 'error' })
      },
    },
  )

  const filteredDiagnoses = useMemo(() => {
    const lowerCaseSearch = search.toLowerCase()

    const matchesSearch = (diagnosis: DiagnosisDTO) => {
      return (
        diagnosis.project.name.toLowerCase().includes(lowerCaseSearch) ||
        diagnosis.formattedDate.includes(lowerCaseSearch) ||
        diagnosis.formattedCicle?.includes(lowerCaseSearch) ||
        diagnosis.phenological_stage.toLowerCase().includes(lowerCaseSearch) ||
        diagnosis.state_acr?.toLowerCase().includes(lowerCaseSearch) ||
        diagnosis.status.label.toLowerCase().includes(lowerCaseSearch)
      )
    }

    return diagnoses?.filter(matchesSearch)
  }, [diagnoses, filteredSearch])

  const shrink = Boolean(search)

  function handleSubmitSearch(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    setFilteredSearch(search)
  }

  function handleClearClick() {
    setSearch('')
    setFilteredSearch('')
  }

  return (
    <Container className={classes.container}>
      <Box className={classes.upper}>
        <Typography variant={'h1'}>Diagnósticos</Typography>
        <form onSubmit={handleSubmitSearch}>
          <InputText
            id='diagnosis'
            InputLabelProps={{
              shrink,
            }}
            className={classNames(classes.inputLabel, {
              [classes.inputLabelNoShrink]: !shrink,
            })}
            InputProps={{
              endAdornment: shrink && (
                <InputAdornment position='end'>
                  <IconButton
                    color='inherit'
                    onClick={() => handleClearClick()}
                    aria-label='Limpar'
                  >
                    <CancelOutlinedIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <Button
            labelOnly
            className={classes.searchButton}
            aria-label='Buscar'
            type='submit'
          >
            <SearchOutlined />
          </Button>
        </form>
        <Button
          color='primary'
          className={classes.button}
          to={routes.Demands('register')}
          component={Link}
          role='link'
        >
          <AddIcon /> Novo Diagnóstico
        </Button>
      </Box>
      {isLoading ? (
        <Loading />
      ) : (
        <Box marginTop='7.2rem'>
          <DiagnosesTable diagnoses={filteredDiagnoses || []} />
        </Box>
      )}
    </Container>
  )
}
